// src/components/CadastroVendedor.jsx
import React, { useEffect, useState } from "react";
import { Save } from "lucide-react";

const CadastroVendedor = ({ token, initialData = {}, isEdit = false, onSubmit }) => {
  const [vendedor, setVendedor] = useState({
    nome: "",
    percentual_comissao: "",
    ...initialData,
  });

  useEffect(() => {
    if (isEdit && initialData && Object.keys(initialData).length > 0) {
      setVendedor({
        nome: initialData.nome || "",
        percentual_comissao:
          initialData.percentualComissao === null || initialData.percentualComissao === undefined
            ? ""
            : String(initialData.percentualComissao),
      });
    }
  }, [initialData, isEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVendedor((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      Nome: (vendedor.nome || "").trim(),
      PercentualComissao:
        vendedor.percentual_comissao === "" ? null : Number(String(vendedor.percentual_comissao).replace(",", ".")),
    };

    if (!payload.Nome) {
      alert("Informe o nome do vendedor.");
      return;
    }

    if (payload.PercentualComissao !== null && Number.isNaN(payload.PercentualComissao)) {
      alert("Percentual de comissão inválido.");
      return;
    }

    await onSubmit(payload, token);
  };

  const inputClass = `
    w-full px-3 py-2.5 rounded-xl border outline-none transition
    zen-card border-gray-300 text-gray-900 placeholder:text-gray-400
    focus:ring-2 focus:ring-blue-500/60
    dark:bg-slate-950/40 dark:border-white/10 dark:text-white dark:placeholder:text-slate-400
    dark:focus:ring-blue-400/40
  `;

  const labelClass = "block text-sm font-medium text-gray-700 dark:text-slate-200 mb-1";

  return (
    <div className="max-w-3xl mx-auto">
      <div className="zen-card rounded-2xl p-6 md:p-8 shadow-sm dark:backdrop-blur">
        <div className="flex justify-between items-start mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white">
              {isEdit ? "Editar Vendedor" : "Cadastro de Vendedor"}
            </h2>
            <p className="text-sm text-gray-500 dark:text-slate-300/80 mt-1">
              Preencha os dados para {isEdit ? "editar o" : "cadastrar um novo"} vendedor.
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="zen-card rounded-2xl p-4 dark:bg-white/5 dark:border-white/10">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="md:col-span-2">
                <label className={labelClass}>Nome</label>
                <input
                  name="nome"
                  value={vendedor.nome}
                  onChange={handleChange}
                  className={inputClass}
                  placeholder="Ex.: João da Silva"
                  required
                />
              </div>

              <div className="md:col-span-1">
                <label className={labelClass}>Percentual de Comissão (%)</label>
                <input
                  name="percentual_comissao"
                  value={vendedor.percentual_comissao}
                  onChange={handleChange}
                  className={inputClass}
                  placeholder="Ex.: 5"
                  inputMode="decimal"
                />
                <p className="text-xs mt-1 text-gray-500 dark:text-slate-300/70">
                  Deixe vazio se não tiver comissão.
                </p>
              </div>
            </div>
          </div>

          <div className="flex justify-end pt-2">
            <button
              type="submit"
              className="
                inline-flex items-center gap-2 px-6 py-3 rounded-xl font-semibold text-sm transition
                bg-blue-600 text-white hover:bg-blue-500
              "
            >
              <Save size={18} />
              {isEdit ? "Salvar Alterações" : "Cadastrar Vendedor"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CadastroVendedor;
